import script from "./InitiativeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitiativeView.vue?vue&type=script&setup=true&lang=ts"

import "./InitiativeView.vue?vue&type=style&index=0&id=6d1d862c&lang=scss"

const __exports__ = script;

export default __exports__